import React, { useState } from "react";
import CartModal from "../../Components/CartModal";
import { useCart } from "../../Contexts/CartContext";
import ShroudforTruncheonMeterV2 from "../../Assets/Shroud for Truncheon Meter V2.webp";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS

const Shroud_for_Truncheon_Meter_V2 = () => {
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    const product = {
      id: 40,
      name: "Shroud for Truncheon Meter V2",
      price: 420,
      image: ShroudforTruncheonMeterV2,
    };
    addToCart({ ...product, quantity: 1 });
    setShowModal(true);
  };

  return (
    <div className="container mt-3">
      {" "}
      {/* Add margin top to the container */}
      <div className="row">
        <div className="col-md-6">
          <div
            id="productCarousel"
            className="carousel slide"
            data-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img
                  src={ShroudforTruncheonMeterV2}
                  alt="shroud for truncheon meter V2"
                  className="d-block w-100"
                />
              </div>
              {/* Add more images to the carousel as needed */}
            </div>
            <a
              className="carousel-control-prev"
              href="#productCarousel"
              role="button"
              data-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Previous</span>
            </a>
            <a
              className="carousel-control-next"
              href="#productCarousel"
              role="button"
              data-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Next</span>
            </a>
          </div>
        </div>

        <div className="col-md-6">
          <div className="product-details">
            <h2 className="product-name">Shroud for Truncheon Meter V2</h2>
            <p className="product-price">₹{420}</p>
            <button className="btn btn-primary" onClick={handleAddToCart}>
              Add to Cart
            </button>
            <p className="product-description mt-3 text-justify">
              <ul>
                <li>Replacement Shroud for the Bluelab Truncheon</li>
                <li>
                  This conductivity shroud is compatible with all Bluelab
                  Conductivity/Temperature probes. Please note that it is only
                  suitable for specific Bluelab Truncheon Meters and is not
                  designed for use with twist-type probes.
                </li>
              </ul>
            </p>
          </div>
        </div>
      </div>
      {/* Conditionally render the CartModal based on showModal */}
      {showModal && <CartModal onClose={() => setShowModal(false)} />}
    </div>
  );
};

export default Shroud_for_Truncheon_Meter_V2;
